import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

/**
 * Initializes Swiper galleries in post content.
 */
export const initGalleries = (): void => {
  const galleries = document.querySelectorAll<HTMLElement>(
    ".post-content-gallery__slider",
  );

  if (galleries.length === 0) {
    return;
  }

  galleries.forEach((gallery) => {
    if (gallery.dataset.initialized === "true") return;
    gallery.dataset.initialized = "true";

    // Strictly scope navigation and pagination selectors locally
    const nextEl = gallery.querySelector<HTMLElement>(
      ".post-content-gallery__next",
    );
    const prevEl = gallery.querySelector<HTMLElement>(
      ".post-content-gallery__prev",
    );
    const paginationEl = gallery.querySelector<HTMLElement>(
      ".post-content-gallery__pagination",
    );

    new Swiper(gallery, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      autoHeight: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });
  });

  console.log(`[Gallery] Isolated Swiper instances initialized safely.`);
};
